import { GrThreeD as THREE_D } from '@mirai/icons/build/gr/GrThreeD';
import { LuBedDouble as BED_DOUBLE } from '@mirai/icons/build/lu/LuBedDouble';
import { LuBedSingle as BED_SINGLE } from '@mirai/icons/build/lu/LuBedSingle';
import { LuHotel as HOTEL } from '@mirai/icons/build/lu/LuHotel';
import { MdAccessAlarm as ALARM } from '@mirai/icons/build/md/MdAccessAlarm';
import { MdCloseFullscreen as CLOSE_FULLSCREEN } from '@mirai/icons/build/md/MdCloseFullscreen';
import { MdMailOutline as MAIL } from '@mirai/icons/build/md/MdMailOutline';
import { MdMoreVert as MORE } from '@mirai/icons/build/md/MdMoreVert';
import { MdOutlineAccountCircle as ACCOUNT } from '@mirai/icons/build/md/MdOutlineAccountCircle';
import { MdOutlineAddToPhotos as ADD_EXTRAS } from '@mirai/icons/build/md/MdOutlineAddToPhotos';
import { MdOutlineArrowUpward as ARROW_UP } from '@mirai/icons/build/md/MdOutlineArrowUpward';
import { MdOutlineAssignment as ASSIGNMENT } from '@mirai/icons/build/md/MdOutlineAssignment';
import { MdOutlineAutorenew as CLEAR } from '@mirai/icons/build/md/MdOutlineAutorenew';
import { MdOutlineCalendarToday as CALENDAR } from '@mirai/icons/build/md/MdOutlineCalendarToday';
import { MdOutlineCallEnd as HANG_UP } from '@mirai/icons/build/md/MdOutlineCallEnd';
import { MdOutlineCurrencyExchange as CURRENCY } from '@mirai/icons/build/md/MdOutlineCurrencyExchange';
import { MdOutlineEditCalendar as CALENDAR_EDIT } from '@mirai/icons/build/md/MdOutlineEditCalendar';
import { MdOutlineEventBusy as CALENDAR_BUSY } from '@mirai/icons/build/md/MdOutlineEventBusy';
import { MdOutlineFreeCancellation as CALENDAR_CANCEL } from '@mirai/icons/build/md/MdOutlineFreeCancellation';
import { MdOutlineGroup as GROUP } from '@mirai/icons/build/md/MdOutlineGroup';
import { MdOutlineGroups as GROUPS } from '@mirai/icons/build/md/MdOutlineGroups';
import { MdOutlineLanguage as LANGUAGE } from '@mirai/icons/build/md/MdOutlineLanguage';
import { MdOutlineLink as LINK } from '@mirai/icons/build/md/MdOutlineLink';
import { MdOutlineListAlt as LIST } from '@mirai/icons/build/md/MdOutlineListAlt';
import { MdOutlineLocalOffer as PROMO } from '@mirai/icons/build/md/MdOutlineLocalOffer';
import { MdOutlineLocationOn as LOCATION } from '@mirai/icons/build/md/MdOutlineLocationOn';
import { MdOutlineLock as LOCK } from '@mirai/icons/build/md/MdOutlineLock';
import { MdOutlineLogout as LOGOUT } from '@mirai/icons/build/md/MdOutlineLogout';
import { MdOutlineMinimize as MINIMIZE } from '@mirai/icons/build/md/MdOutlineMinimize';
import { MdOutlineOutput as URL } from '@mirai/icons/build/md/MdOutlineOutput';
import { MdOutlinePageview as SITE } from '@mirai/icons/build/md/MdOutlinePageview';
import { MdOutlinePeopleAlt as PEOPLE } from '@mirai/icons/build/md/MdOutlinePeopleAlt';
import { MdOutlinePersonOff as PERSON_OFF } from '@mirai/icons/build/md/MdOutlinePersonOff';
import { MdOutlinePhone as PHONE } from '@mirai/icons/build/md/MdOutlinePhone';
import { MdOutlinePlayCircle as PLAY } from '@mirai/icons/build/md/MdOutlinePlayCircle';
import { MdOutlinePrint as PRINT } from '@mirai/icons/build/md/MdOutlinePrint';
import { MdOutlineRefresh as REFRESH } from '@mirai/icons/build/md/MdOutlineRefresh';
import { MdOutlineSchedule as SCHEDULE } from '@mirai/icons/build/md/MdOutlineSchedule';
import { MdOutlineSupportAgent as AGENT } from '@mirai/icons/build/md/MdOutlineSupportAgent';
import { MdOutlineTune as TUNE } from '@mirai/icons/build/md/MdOutlineTune';
import { MdOutlineWhatsapp as WHATSAPP } from '@mirai/icons/build/md/MdOutlineWhatsapp';
import { MdOutlineWorkspacePremium as PREMIUM } from '@mirai/icons/build/md/MdOutlineWorkspacePremium';
import { MdPersonOutline as PERSON } from '@mirai/icons/build/md/MdPersonOutline';
import { MdPhotoSizeSelectSmall as SIZE } from '@mirai/icons/build/md/MdPhotoSizeSelectSmall';
import { MdStop as RECORD } from '@mirai/icons/build/md/MdStop';
import { MdUnfoldMore as UNFOLD } from '@mirai/icons/build/md/MdUnfoldMore';
import { TbDiscountCheck as OFFER } from '@mirai/icons/build/tb/TbDiscountCheck';
import { TbView360Number as VIEW_360 } from '@mirai/icons/build/tb/TbView360Number';
import { ICON as ICON_BASE } from '@mirai/ui';

import { ICON_AMENITIES } from './ICON.AMENITIES';

export const ICON = {
  ...ICON_BASE,
  ACCOUNT,
  ADD_EXTRAS,
  ALARM,
  AGENT,
  ARROW_UP,
  ASSIGNMENT,
  BED_DOUBLE,
  BED_SINGLE,
  CALENDAR,
  CALENDAR_BUSY,
  CALENDAR_CANCEL,
  CALENDAR_EDIT,
  CLEAR,
  CLOSE_FULLSCREEN,
  CURRENCY,
  GROUP,
  GROUPS,
  HANG_UP,
  HOTEL,
  LANGUAGE,
  LINK,
  LIST,
  LOCATION,
  LOCK,
  LOGOUT,
  MAIL,
  MESSAGE: ICON_AMENITIES['215'],
  MINIMIZE,
  MORE,
  OFFER,
  PEOPLE,
  PERSON,
  PERSON_OFF,
  PHONE,
  RECORD,
  PLAY,
  PREMIUM,
  PRINT,
  PROMO,
  REFRESH,
  SCHEDULE,
  THREE_D,
  TUNE,
  // SUPPORT_AGENT,
  SITE,
  SIZE,
  UNFOLD,
  URL,
  VIEW_360,
  WHATSAPP,
  // Amenities & Features,
  ...ICON_AMENITIES,
};
